import React, { useState, useEffect } from 'react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { IconButton, Popover } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ReplyIcon from '@mui/icons-material/Reply';
import DeleteIcon from '@mui/icons-material/Delete';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import { doc, deleteDoc } from 'firebase/firestore';
import { db } from 'app/firebase';
import { useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';
import { IMessage } from 'interfaces/message.interface';
import ReactionBar from './ReactionBar';
import { getRef } from 'utils/Firebase.util';
import { useDispatch } from 'react-redux';
import { updateReplyToMessage } from 'features/auth/chatSlice';

type IOptions = {
  userId?: number;
  username: string;
  msgId: string;
  messages: IMessage[];
  reaction?: string[];
  sender?: boolean;
  hover?: boolean;
};

const Options: React.FC<IOptions> = ({
  userId,
  msgId,
  messages,
  reaction,
  sender,
  username,
  hover,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const authState = useAppSelector(selectAuth);
  const [dbRef, setDbref] = useState<string>('');
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  useEffect(() => {
    const getDocs = async () => {
      if (authState.id && userId) {
        const docRef = await getRef(authState.id, userId);
        if (docRef) setDbref(docRef);
      }
    };
    getDocs();
  }, [authState.id, userId]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = async () => {
    try {
      if (dbRef === `${userId}-${authState.id}`) {
        await deleteDoc(doc(db, 'chats', dbRef, 'messages', msgId));
      } else {
        await deleteDoc(
          doc(db, 'chats', `${authState.id}-${userId}`, 'messages', msgId)
        );
      }
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  const handleReply = () => {
    const message = messages.find(message => message.id === msgId);
    if (message) {
      const { id, text, type, uid } = message;
      const { date, ...otherProps } = message;
      dispatch(
        updateReplyToMessage({ id, text, type, username, uid, msg: otherProps })
      );
      handleClose();
    }
  };

  const menuItemStyle = {
    display: 'flex',
    aligntems: 'center',
    gap: '5px',
    color: 'gray',
  };

  return (
    <div className="options">
      <IconButton
        onClick={handleClick}
        style={{ width: 'fit-content', height: 'fit-content', color: 'white' }}
      >
        <MoreHorizIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      >
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem style={menuItemStyle}>
            <ReactionBar
              reaction={reaction}
              messages={messages}
              msgId={msgId}
              docRef={dbRef}
              handleCloseParent={handleClose}
            >
              <EmojiEmotionsIcon /> React
            </ReactionBar>
          </MenuItem>
          <MenuItem style={menuItemStyle} onClick={handleReply}>
            <ReplyIcon /> Reply
          </MenuItem>
          {!sender && (
            <MenuItem style={menuItemStyle} onClick={handleDelete}>
              <DeleteIcon /> Unsend
            </MenuItem>
          )}
        </Menu>
      </Popover>
    </div>
  );
};

export default Options;
